export function formateStrToDate (str = '2020年2月27日 20:00') {
  const year = /\d{4}/.exec(str)[0]
  let month = /(\d{1,2})月/.exec(str)[0]
  month = month.substring(0, month.indexOf('月'))
  let day = /(\d{1,2})日/.exec(str)[0]
  day = day.substring(0, day.indexOf('日'))
  let hours = /(\d{1,2}):/.exec(str)[0]
  hours = hours.substring(0, hours.indexOf(':'))
  let second = /:(\d{1,2})/.exec(str)[0]
  second = second.substring(1)
  const date = new Date()
  date.setFullYear(Number.parseInt(year))
  date.setMonth((Number.parseInt(month) - 1))
  date.setDate(Number.parseInt(day))
  date.setHours(Number.parseInt(hours))
  date.setSeconds(Number.parseInt(second))
  return date.getTime()
}

export function formateRegexToDate (str = '2020-02-10 20:00') {
  const year = Number.parseInt(str.substring(0, 4))
  const month = Number.parseInt(str.substr(str.indexOf('-') + 1, 2))
  const day = Number.parseInt(str.substr(str.lastIndexOf('-') + 1, 2))
  const hours = Number.parseInt(str.substr(str.indexOf(' ') + 1, 2))
  const minutes = Number.parseInt(str.substr(str.indexOf(':') + 1, 2))
  const second = Number.parseInt(str.substr(str.lastIndexOf(':') + 1, 2))
  const date = new Date()
  date.setFullYear(Number.parseInt(year))
  date.setMonth((Number.parseInt(month) - 1))
  date.setDate(Number.parseInt(day))
  date.setHours(Number.parseInt(hours))
  date.setMinutes(Number.parseInt(minutes))
  date.setSeconds(Number.parseInt(second))
  return date
}

export function formateDateTostr (date, regex = 'YYYY年MM月DD日 星期WEEK HH:mm:ss') {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  let week = date.getDay()
  switch (week) {
    case 0:
      week = '日'
      break
    case 1:
      week = '一'
      break
    case 2:
      week = '二'
      break
    case 3:
      week = '三'
      break
    case 4:
      week = '四'
      break
    case 5:
      week = '五'
      break
    case 6:
      week = '六'
  }
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const second = date.getSeconds()
  regex = regex.replace('YYYY', year)
  regex = regex.replace('MM', month < 10 ? `0${month}` : month)
  regex = regex.replace('DD', day < 10 ? `0${day}` : day)
  regex = regex.replace('WEEK', week)
  regex = regex.replace('HH', hours < 10 ? `0${hours}` : hours)
  regex = regex.replace('mm', minutes < 10 ? `0${minutes}` : minutes)
  regex = regex.replace('ss', second < 10 ? `0${second}` : second)
  return regex
}

export function liverIsEnd (str = '2020年2月27日 星期四 20:54') {
  str = str.substr(0, str.lastIndexOf(':'))
  const time = formateStrToDate(str)
  return (time - new Date().getTime()) > 0
}

export function getBeforeTimeStr1 (str = '2020-02-27 20:00:00') {
  const year = Number.parseInt(str.substring(0, 4))
  const month = Number.parseInt(str.substr(str.indexOf('-') + 1, 2))
  const day = Number.parseInt(str.substr(str.lastIndexOf('-') + 1, 2))
  const hours = Number.parseInt(str.substr(str.indexOf(' ') + 1, 2))
  const minutes = Number.parseInt(str.substr(str.indexOf(':') + 1, 2))
  // const second = Number.parseInt(str.substr(str.lastIndexOf(':') + 1, 2))
  const date = new Date()
  const _year = date.getFullYear()
  const _month = date.getMonth() + 1
  const _day = date.getDate()
  const _hours = date.getHours()
  const _minutes = date.getMinutes()
  // const _second = date.getSeconds()
  if (_year > year) {
    return `${_year - year}年前`
  } else if (_month > month) {
    return `${_month - month}月前`
  } else if (_day > day) {
    return `${_day - day}天前`
  } else if (_hours > hours) {
    return `${_hours - hours}小时前`
  } else if (_minutes > minutes) {
    return `${_minutes - minutes}分钟前`
  } else {
    // return `${_second - second}秒前`
    return '刚刚'
  }
}
export function getBeforeTimeStr (str = '2020-02-27 20:00:00') {
  const year = Number.parseInt(str.substring(0, 4))
  const month = Number.parseInt(str.substr(str.indexOf('-') + 1, 2))
  const day = Number.parseInt(str.substr(str.lastIndexOf('-') + 1, 2))
  const hours = Number.parseInt(str.substr(str.indexOf(' ') + 1, 2))
  const minutes = Number.parseInt(str.substr(str.indexOf(':') + 1, 2))
  const second = Number.parseInt(str.substr(str.lastIndexOf(':') + 1, 2))
  const date = new Date()
  date.setFullYear(year)
  date.setMonth(month - 1)
  date.setDate(day)
  date.setHours(hours)
  date.setMinutes(minutes)
  date.setSeconds(second)
  const difference = Number.parseInt((new Date().getTime() - date.getTime()) / 1000)
  if (difference >= 365 * 24 * 60 * 60) {
    return `${Number.parseInt(difference / (365 * 24 * 60 * 60))}年前`
  } else if (difference >= 30 * 24 * 60 * 60) {
    return `${Number.parseInt(difference / (30 * 24 * 60 * 60))}个月前`
  } else if (difference >= 24 * 60 * 60) {
    return `${Number.parseInt(difference / (24 * 60 * 60))}天前`
  } else if (difference >= 60 * 60) {
    return `${Number.parseInt(difference / (60 * 60))}小时前`
  } else if (difference >= 60) {
    return `${Number.parseInt(difference / 60)}分钟前`
  } else {
    return `${difference}秒前`
  }
}
